<template>
  <div class="container">
    <div class="headerLogo">
      <img src="../../assets/logo.png" class="logo" @click="$router.push({name:'Home'})" />
    </div>

    <div class="bodyContainer">
      <div class="img"></div>
      <div class="login-box">
        <div class="loginTitle">忘记密码</div>
        <div class="loginTitle1">Hi，欢迎来到释空</div>

        <div class="inputContainer">
          <el-input v-model="formData.phone" placeholder="手机号码"></el-input>
        </div>

        <div class="codeContainer">
          <el-input v-model="formData.sms_code" placeholder="验证码"></el-input>
          <div class="send" @click="getCode">{{ codeMsg }}</div>
        </div>

        <div class="inputContainer">
          <el-input v-model="formData.password" placeholder="登录密码" show-password></el-input>
        </div>
        <div class="inputContainer">
          <el-input v-model="formData.password2" placeholder="重复密码" show-password></el-input>
        </div>

        <div class="loginButton">
          <div class="buttonTitle" @click="handleSubmit('formInline')">确 认</div>
        </div>
      </div>
    </div>
    <v-footer></v-footer>
  </div>
</template>

<script>
import footer from "../footer";
import { mapMutations, mapActions } from "vuex";

export default {
  name: "forgetpwd",
  components: {
    "v-footer": footer
  },
  data() {
    return {
      formData: {
        phone: "",
        password: "",
        password2: "",
        sms_code: ""
      },
      // 是否禁用按钮
      codeDisabled: false,
      // 倒计时秒数
      countdown: 60,
      // 按钮上的文字
      codeMsg: "发送验证码",
      // 定时器
      timer: null
    };
  },
  methods: {
    ...mapMutations(["SET_USER_LOGIN_INFO"]),
    ...mapActions(["login"]),
    handleSubmit(name) {
      if (this.formData.phone.length != 11) {
        this.$message({
          message: "请输入手机号",
          type: "warning"
        });
        return;
      } else if (this.formData.sms_code.length < 0  && this.formData.sms_code.length !=6) {
        this.$message({
          message: "请输入验证码",
          type: "warning"
        });
        return;
      } else if (
        this.formData.password.length < 0 ||
        this.formData.password2.length < 0 ||
        this.formData.password != this.formData.password2
      ) {
        this.$message({
          message: "密码输入有误或两次输入不一致",
          type: "warning"
        });
        return;
      }

      const father = this;
      this.$http.forgetPwd(this.formData).then(res => {
        if (res.code == 200) {
          this.$message({
            message: "密码修改成功",
            type: "success"
          });
          this.$router.push("login");
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    getCode() {
      // 验证码60秒倒计时
      if (!this.timer) {
        this.$http.sendCode({ phone: this.formData.phone }).then(res => {
          if (res.code == 200) {
            this.$message({
              message: "验证码已发送",
              type: "success"
            });
          } else {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          }
        });
        this.timer = setInterval(() => {
          if (this.countdown > 0 && this.countdown <= 60) {
            this.countdown--;
            if (this.countdown !== 0) {
              this.codeMsg = "重新发送(" + this.countdown + ")";
            } else {
              clearInterval(this.timer);
              this.codeMsg = "获取验证码";
              this.countdown = 60;
              this.timer = null;
              this.codeDisabled = false;
            }
          }
        }, 1000);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
}
.headerLogo {
  height: 96px;
  padding: 24px 0 0 120px;
  background: #fff;
  text-align: left;
  // border: 1px dashed red;
  cursor: pointer;
}

.bodyContainer {
  position: relative;
  width: 100%;
  height: 720px;
  background-color: #ed3f14;
  .img {
    width: 1300px;
    height: 100%;
    margin: 0 auto;
    background-image: url("../../assets/Shop_Login_Bg.png");
  }
}
.login-box {
  position: absolute;
  width: 400px;
  height: 490px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.2);
  margin: 0 0 0 70%;
  top: 50%;
  transform: translateY(-50%);
  text-align: left;
}

.user_input {
  width: 320px;
  height: 40px;
}

.inputContainer {
  width: 320px;
  height: 40px;
  margin: 32px auto;
}

.rowContainer {
  width: 320px;
  height: 40px;
  background-color: black;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
}

.codeContainer {
  width: 320px;
  height: 40px;
  margin: 0 auto;
  flex-direction: row;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
}

.send {
  min-width: 100px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(239, 45, 35, 1);
  line-height: 22px;
  margin: 10px 0 0 40px;
  cursor: pointer;
}

.user_input:empty::before {
  content: attr(placeholder);
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.25);
  line-height: 22px;
}
.pwd_input {
  width: 320px;
  height: 40px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(217, 217, 217, 1);
  margin: 20px 40px 10px 40px;
  padding-left: 20px;
}
.pwd_input:empty::before {
  content: attr(placeholder);
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.25);
  line-height: 22px;
}

.loginButton {
  width: 320px;
  height: 40px;
  background: rgba(239, 45, 35, 1);
  margin: 32px 0 0 40px;
  position: relative;
}

.buttonTitle {
  font-size: 16px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  text-align: center;
  padding: 8px 0 0 0;
}

.loginTitle {
  font-size: 20px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  line-height: 28px;
  padding: 32px 0 0 40px;
}

.loginTitle1 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.45);
  line-height: 22px;
  padding: 16px 0 0 40px;
}

.rowContainer {
  /*flex-direction: row;*/
  width: 320px;
  height: 20px;

  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  margin-left: 40px;

  .forgetContaner {
    width: 100px;
    height: 20px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 20px;
    /*  margin: 16px 0 0 40px;*/
  }
  .rowContainer2 {
    width: 200px;
    height: 20px;
    display: flex;
    justify-content: flex-end;
  }

  .signContainer {
    font-size: 12px;
    font-weight: 400;
    font-family: PingFangSC-Regular;
    color: rgba(0, 0, 0, 0.45);
    line-height: 20px;
    height: 20px;
    /*  margin: 16px 0 0 40px;*/
  }

  .signContaner2 {
    font-size: 12px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(239, 45, 35, 1);
    line-height: 20px;
    height: 20px;
    /* margin: 16px 32px 0 10px;*/
  }
}
</style>
